
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_1gul3_154",
  "tab-header-scroll-container": "awsui_tab-header-scroll-container_14rmt_1gul3_163",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_1gul3_169",
  "pagination-button": "awsui_pagination-button_14rmt_1gul3_187",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_1gul3_194",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_1gul3_197",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_1gul3_201",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_1gul3_204",
  "actions-container": "awsui_actions-container_14rmt_1gul3_209",
  "tabs-tab": "awsui_tabs-tab_14rmt_1gul3_217",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_1gul3_227",
  "tabs-tab-header-container": "awsui_tabs-tab-header-container_14rmt_1gul3_238",
  "tabs-tab-dismiss": "awsui_tabs-tab-dismiss_14rmt_1gul3_249",
  "tabs-tab-action": "awsui_tabs-tab-action_14rmt_1gul3_249",
  "refresh": "awsui_refresh_14rmt_1gul3_254",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_1gul3_258",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_1gul3_300",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_1gul3_378",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_1gul3_385",
  "tabs-tab-focusable": "awsui_tabs-tab-focusable_14rmt_1gul3_389",
  "root": "awsui_root_14rmt_1gul3_393",
  "tabs": "awsui_tabs_14rmt_1gul3_154",
  "tabs-content": "awsui_tabs-content_14rmt_1gul3_431",
  "fit-height": "awsui_fit-height_14rmt_1gul3_435",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_1gul3_441",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_1gul3_455",
  "with-paddings": "awsui_with-paddings_14rmt_1gul3_455",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_1gul3_466",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_14rmt_1gul3_477",
  "tabs-tab-focused": "awsui_tabs-tab-focused_14rmt_1gul3_481"
};
  